<template>
  <div>
    <div v-if="item.details.router">
      {{ item.action == "link_camera_with_router" ? "Linked" : "Unlinked" }}
      camera
      <span
        class="sim-hover primary--text"
        @click="openCameraDialog(item.details.router.cameraExid)"
      >
        {{ item.details.router.cameraName }}
      </span>
      {{ item.action == "link_camera_with_router" ? "with" : "from" }}
      router
      <span
        class="sim-hover primary--text"
        @click="$emit('open-router-dialog', item.details.router)"
      >
        {{ item.details.router.serialNumber }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    openCameraDialog(cameraId) {
      this.$emit("open-camera-dialog", cameraId)
    },
    openRouterDialog(router) {
      this.$emit("open-router-dialog", router)
    },
  },
}
</script>
